import '../../components/helper-modules/entry-base';
import Util from '../../components/helper-modules/util';

// - check number
const checkPhone = phone => (/^1[34578]\d{9}$/.test(phone));

$('.form-checkbox').click();

$('#non-username').focus(function () {
  const _this = $(this);
  const _iconInput = _this.parents('.input-container').find('.icon-input');
  _iconInput.hide();
  if (_this.val() === _this.attr('name') || _this.hasClass('error')) {
    _this.removeClass('error').val('');
  }
}).blur(function () {
  const _this = $(this);
  const _iconInput = _this.parents('.input-container').find('.icon-input');
  if (_this.val() === '') {
    _iconInput.show();
  }
});


$('#non-phonenum').focus(function () {
  const _this = $(this);
  const _iconInput = _this.parents('.input-container').find('.icon-input');
  _iconInput.hide();
  if (_this.val() === _this.attr('name') || _this.hasClass('error')) {
    _this.removeClass('error').val('');
  }
}).blur(function () {
  const _this = $(this);
  const _iconInput = _this.parents('.input-container').find('.icon-input');
  const _val = _this.val();
  if (_this.val() === '') {
    _iconInput.show();
  } else if (_val !== _this.attr('name') && _val !== _this.attr('data-error')) {
    if (!checkPhone(_this.val())) {
      _this.addClass('error').val('请填写正确的手机号码');
    }
  }
});

Util.checkInputNumber('#non-verification', '请填写正确的验证码', 'num');

// - checkbox
$('.form-checkbox').on('click', function () {
  const $button = $('.form-button');
  if ($(this).hasClass('selected')) {
    $button.removeClass('grey').removeAttr('disabled');
  } else {
    $button.addClass('grey').attr('disabled', 'disabled');
  }
});

// - button
$('.submit-page .form-button').click(() => {
  let isdone = true;

  $('.non-owner .form-input').each(function () {
    const _this = $(this);
    const _val = _this.val();
    if (_val === '' || _val === _this.attr('name') || _this.hasClass('error')) {
      isdone = false;
      if (!_this.hasClass('error')) {
        _this.addClass('error').val(_this.attr('data-error'));
        $('.icon-input').hide();
      }
    }
    if (!$('.form-checkbox').hasClass('selected')) {
      isdone = false;
    }
  });
  if (isdone) {
    window.submitSubmitPage();
  }
});

window.isPhoneAvailable = function () {
  const _this = $('#non-phonenum');
  const _iconInput = _this.parents('.input-container').find('.icon-input');
  if (_this.val() === '' || !checkPhone(_this.val())) {
    _iconInput.hide();
    _this.addClass('error').val('请填写正确的手机号码');
    return false;
  }
  return true;
};




// WEBPACK FOOTER //
// src/entries/submit/entry.jsx